import useApi from "../../../../Utils/BackendClient";
import { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { FloatLabel } from "primereact/floatlabel";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { OrgInfoContext } from "../../../../context/OrgInfoProvider";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Tooltip } from "primereact/tooltip";
import { RadioButton } from "primereact/radiobutton";

import commonStyle from "../../CommonStyles.module.css";
import baseUserPic from "../../../../images/Random_user_pic.png";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";

const Organization = ({ isDarkTheme }) => {

    const { fetchOrganizationDetails, fetchDocumentTemplates, updateOrganizationDetails, uploadOrganizationLogo } = useApi();
    const toast = useRef(null);
    const orgCtx = useContext(OrgInfoContext);
    const navigate = useNavigate();

    const [isEdit, setIsEdit] = useState(false);
    const [reloadData, setReloadData] = useState(false);
    const [showUploadMenu, setShowUploadMenu] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);
    const [templates, setTemplates] = useState(null);
    const [organizationDetails, setOrganizationDetails] = useState({
        logo_url: "",
        name: "",
        email: "",
        phone: "",
        contact_person: "",
        cagent_type: "INDIVIDUAL",
        legal_name: "",
        edrpou: "",
        inn: "",
        organization_settings: {
            check_template_id: null,
            close_shift_automatically: false,
            close_shift_hour: 0,
            close_shift_minute: 0
        }
    });

    useEffect(() => {

        const getOrganizatiionDetails = async () => {

            const response = await fetchOrganizationDetails();

            if(response.status === 200){

                if(response.data?.logo_url === null){
                    response.data.logo_url = baseUserPic;
                }

                setOrganizationDetails(response.data);
            }
            else{
                if (response.status === 403) {
                    toast.current.show({ severity: "error", summary: "Помилка відображення організацій", detail: "Користувач не має прав переглядати цю сторінку", life: 3000 });
                }
                else {
                    toast.current.show({ severity: "error", summary: "Помилка відображення організації", detail: "Помилка сервера " + response.status, life: 3000 });
                }
            }
        }

        getOrganizatiionDetails();

    }, [fetchOrganizationDetails, reloadData]);

    const getTemplates = async () => {

        const response = await fetchDocumentTemplates();

        if(response.status === 200){

            let convertedTemplates = [];

            if(response.data.results.length > 0)
            {
                convertedTemplates = response.data.results.reduce((acc, obj) => {
                    acc[+obj.id] = obj.name;
                    return acc;
                }, {});
            };

            console.log(convertedTemplates);

            setTemplates(convertedTemplates);
        }
        else{
            toast.current.show({ severity: "error", summary: "Помилка отримання списку темплейтів", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const items = [
        {
            label: 'Деталі організації',
            icon: 'pi pi-home',
            command: () => {
                setTabShowed(0);
            },
        },
        {
            label: 'Юридична інформація',
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(1);
            },
        },
        {
            label: 'Налаштування',
            icon: 'pi pi-cog',
            command: () => {
                if(templates === null){
                    getTemplates();
                }
                setTabShowed(2);
            },
        }
    ];

    const formik = useFormik({
        initialValues: organizationDetails,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (!values.name) {
                errors.name = "Назва організації не повинна бути пустою";
            }

            if (!values.email) {
                errors.email = "Email не повинен бути пустим";
            }
            else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)){
                errors.email = "Неправильна email адреса. Наприклад: example@email.com";
            }

            if (!values.phone) {
                errors.phone = "Вкажіть, будь ласка, номер телефону";
            }

            if (!values.contact_person) {
                errors.contact_person = "Вкажіть, будь ласка, контактну особу";
            }

            return errors;
        },
        onSubmit: async (values) => {

            const response = await updateOrganizationDetails(values);

            console.log(response);

            if(response.status === 200){
                toast.current.show({ severity: "success", summary: "Успіх", detail: "Дані організації успішно оновлено", life: 3000 });
            }
            else{
                toast.current.show({ severity: "error", summary: "Помилка", detail: "Помилка оновлення даних організації: " + response.status, life: 3000 });
            }

            setIsEdit(false);
        }
    });

    const Upload = async (uploadEvent) => {

        let formData = new FormData();
        formData.append('logo', uploadEvent.files[0], uploadEvent.files[0].name)

        const response = await uploadOrganizationLogo(formData);

        if (response.status === 201) {
            orgCtx.loadOrgData();
            setReloadData(!reloadData);
        }
        else {
            if (response.status === 403) {
                toast.current.show({ severity: "error", summary: "Помилка завантаження лого", detail: "Користувач не має прав змінювати лого", life: 3000 });
            }
            else {
                toast.current.show({ severity: "error", summary: "Помилка завантаження лого", detail: "Помилка сервера " + response.status, life: 3000 });
            }
        }

        setShowUploadMenu(false);
    }

    const enableEdit = (state) => {
        setIsEdit(state);

        if(!state){
            navigate(0);
        }
    }

    const ToolbarRightContent = () => {
        return (<div className="flex flex-wrap gap-2">
            {isEdit && <Button label="Зберегти" severity="success" className={commonStyle.addButton} type="submit" />}
            {!isEdit && <Button label="Редагувати" severity="secondary" className={commonStyle.closeButton} type="button" onClick={() => enableEdit(true)} /> }
            {isEdit && <Button label="Вийти" severity="secondary" className={commonStyle.closeButton} type="button" onClick={() => enableEdit(false)} /> }
        </div>)
    }

    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <Toolbar className="mb-4" end={ToolbarRightContent} />
        <TabMenu model={items} />
        {tabShowed === 0 && <div className={commonStyle.orgContent}>
            <div className="grid">
                <div className="col-3">
                    <div className={commonStyle.portraitdiv}>
                        <img className={commonStyle.portrait} alt={organizationDetails?.name} src={isDarkTheme ? organizationDetails?.dark_theme_logo_url : organizationDetails?.logo_url} style={{ borderRadius: "50%" }} />
                    </div>
                    {!showUploadMenu && <div className="text-center">
                        <Tooltip target=".custom-changelogo-btn" content="Змінити лого" position="left" />
                        <Tooltip target=".custom-deletelogo-btn" content="Видалити лого" position="right" />
                        <Button icon="pi pi-arrow-right-arrow-left" className={`p-button-rounded p-button-danger ${commonStyle.editButton} mt-2 custom-changelogo-btn`} onClick={() => setShowUploadMenu(true)} />
                    </div>}
                    {showUploadMenu && <div className="text-center mt-3">
                        <FileUpload
                            mode="basic"
                            name="demo[]"
                            accept="image/*"
                            maxFileSize={1000000}
                            customUpload
                            uploadHandler={Upload}
                        >
                        </FileUpload>
                    </div>}
                </div>
                <div className="col-3">
                    <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                        <FloatLabel>
                            <InputText
                                name="name"
                                value={formik.values.name}
                                disabled={!isEdit}
                                onChange={(e) => { formik.setFieldValue('name', e.target.value) }}
                                className={formik.errors.name && formik.touched.name ? 'p-invalid w-full' : "w-full"}
                            />
                            <label>Назва організації</label>
                        </FloatLabel>
                        {formik.errors.name && formik.touched.name && (<small className={commonStyle.errorSmall}>{formik.errors.name}</small>)}
                    </div>
                    <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                        <FloatLabel>
                            <InputText
                                name="email"
                                value={formik.values.email}
                                disabled={!isEdit}
                                onChange={(e) => { formik.setFieldValue('email', e.target.value) }}
                                className={formik.errors.email && formik.touched.email ? 'p-invalid w-full' : "w-full"}
                            />
                            <label>E-mail</label>
                        </FloatLabel>
                        {formik.errors.email && formik.touched.email && (<small className={commonStyle.errorSmall}>{formik.errors.email}</small>)}
                    </div>
                </div>
                <div className="col-3">
                    <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                        <FloatLabel>
                            <InputText
                                name="phone"
                                value={formik.values.phone}
                                disabled={!isEdit}
                                onChange={(e) => { formik.setFieldValue('phone', e.target.value) }}
                                className={formik.errors.phone && formik.touched.phone ? 'p-invalid w-full' : "w-full"}
                            />
                            <label>Телефон</label>
                        </FloatLabel>
                        {formik.errors.phone && formik.touched.phone && (<small className={commonStyle.errorSmall}>{formik.errors.phone}</small>)}
                    </div>
                    <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                        <FloatLabel>
                            <InputText
                                name="contact_person"
                                value={formik.values.contact_person}
                                disabled={!isEdit}
                                onChange={(e) => { formik.setFieldValue('contact_person', e.target.value) }}
                                className={formik.errors.contact_person && formik.touched.contact_person ? 'p-invalid w-full' : "w-full"}
                            />
                            <label>Відповідальна особа</label>
                        </FloatLabel>
                        {formik.errors.contact_person && formik.touched.contact_person && (<small className={commonStyle.errorSmall}>{formik.errors.contact_person}</small>)}
                    </div>
                </div>
            </div>
        </div>}
        {tabShowed === 1 && <div className="grid">
            <div className={`${commonStyle.leftMenu} col-3`}>
                <div className={`${commonStyle.radioButtonBlock}`}>
                    <div className={commonStyle.accountingRadio}>
                        <RadioButton value="INDIVIDUAL" checked={formik.values.cagent_type === "INDIVIDUAL"} disabled={!isEdit} onChange={(e) => { formik.setFieldValue('cagent_type', "INDIVIDUAL"); }} />
                        <label className="ml-2 text-lg">Фізична особа</label>
                    </div>
                    <div className={commonStyle.accountingRadio}>
                        <RadioButton value="LEGAL" checked={formik.values.cagent_type === "LEGAL"} disabled={!isEdit} onChange={(e) => { formik.setFieldValue('cagent_type', "LEGAL"); }} />
                        <label className="ml-2 text-lg">Юридична особа</label>
                    </div>
                    <div className={commonStyle.accountingRadio}>
                        <RadioButton value="FOP" checked={formik.values.cagent_type === "FOP"} disabled={!isEdit} onChange={(e) => { formik.setFieldValue('cagent_type', "FOP"); }} />
                        <label className="ml-2 text-lg">ФОП</label>
                    </div>
                </div>
            </div>
            <div className="col-9">
                <div className="p-inputgroup flex-column mt-5">
                    <FloatLabel>
                        <InputText
                            name="legal_name"
                            value={formik.values.legal_name}
                            disabled={!isEdit}
                            onChange={(e) => { formik.setFieldValue('legal_name', e.target.value) }}
                        />
                        <label>Юридична назва контрагента</label>
                    </FloatLabel>
                </div>
                {formik.values.cagent_type === "LEGAL" ? (<div className="p-inputgroup flex-column mt-5">
                    <FloatLabel>
                        <InputText
                            name="EDRPOU"
                            value={formik.values.edrpou}
                            disabled={!isEdit}
                            onChange={(e) => { formik.setFieldValue('edrpou', e.target.value) }}
                        />
                        <label>ЄДРПОУ</label>
                    </FloatLabel>
                </div>) :
                    (<div className="p-inputgroup flex-column mt-5">
                        <FloatLabel>
                            <InputText
                                name="IPN"
                                value={formik.values.inn}
                                disabled={!isEdit}
                                onChange={(e) => { formik.setFieldValue('inn', e.target.value) }}
                            />
                            <label>ІПН</label>
                        </FloatLabel>
                    </div>)}
                <div className="p-inputgroup flex-column mt-5">
                    <FloatLabel>
                        <InputText
                            name="bank_name"
                            value={formik.values.bank_name}
                            disabled={!isEdit}
                            onChange={(e) => { formik.setFieldValue('bank_name', e.target.value) }}
                        />
                        <label>Назва банку</label>
                    </FloatLabel>
                </div>
                <div className="p-inputgroup flex-column mt-5">
                    <FloatLabel>
                        <InputText
                            name="bank_mfo"
                            value={formik.values.bank_mfo}
                            disabled={!isEdit}
                            onChange={(e) => { formik.setFieldValue('bank_mfo', e.target.value) }}
                        />
                        <label>МФО</label>
                    </FloatLabel>
                </div>
                <div className="p-inputgroup flex-column mt-5">
                    <FloatLabel>
                        <InputText
                            name="bank_account"
                            value={formik.values.bank_account}
                            disabled={!isEdit}
                            onChange={(e) => { formik.setFieldValue('bank_account', e.target.value) }}
                        />
                        <label>Номер банківського рахунку</label>
                    </FloatLabel>
                </div>
            </div>
        </div>}
        {tabShowed === 2 && <div className="grid">
            <div className="col-3 flex-column ml-2">
                <div className="p-inputgroup mt-5">
                    <FloatLabel>
                        <Dropdown
                            value={formik.values.organization_settings.check_template_id}
                            onChange={(e) => formik.setFieldValue('organization_settings.check_template_id', e.value)}
                            options={
                                templates
                                    ? Object.entries(templates).map(([key, label]) => ({
                                        label: label,
                                        value: +key,
                                    }))
                                    : []
                            }
                            disabled={!isEdit}
                            showClear
                            optionLabel="label"
                            optionValue="value"
                            className="w-full"
                        />
                        <label>Шаблон для чеку</label>
                    </FloatLabel>
                </div>
                <div className={`${commonStyle.checkBoxInput}`}>
                        <div className={`${commonStyle.checkboxStyle} p-inputgroup flex-1"`}>
                            <Checkbox
                                name="automaticalShiftClosure"
                                onChange={(e) => { formik.setFieldValue('organization_settings.close_shift_automatically', !formik.values.organization_settings.close_shift_automatically) }}
                                disabled={!isEdit}
                                checked={formik.values.organization_settings.close_shift_automatically}
                            />
                            <label>Автозакриття зміни</label>
                        </div>
                </div>
                {formik.values.organization_settings.close_shift_automatically && <div className="p-inputgroup mt-5">
                    <FloatLabel>
                        <InputNumber
                            name="closingHour"
                            value={formik.values.organization_settings.close_shift_hour}
                            disabled={!isEdit}
                            onChange={(e) => { formik.setFieldValue('organization_settings.close_shift_hour', e.value) }}
                        />
                        <label>Година автозакриття зміни</label>
                    </FloatLabel>
                </div>}
                {formik.values.organization_settings.close_shift_automatically && <div className="p-inputgroup mt-5">
                    <FloatLabel>
                        <InputNumber
                            name="closingHourMinutes"
                            value={formik.values.organization_settings.close_shift_minute}
                            disabled={!isEdit}
                            onChange={(e) => { formik.setFieldValue('organization_settings.close_shift_minute', e.value) }}
                        />
                        <label>Хвилина актозакриття зміни</label>
                    </FloatLabel>
                </div>}
            </div>
        </div>}
    </form>)
}

export default Organization;